import { useEffect } from 'react';
import { useProjectStore } from '../store';

/**
 * Branche les raccourcis clavier Ctrl/Cmd+Z (undo) et Ctrl/Cmd+Shift+Z ou Ctrl+Y (redo)
 * sur le système d'historique du store PERT (nodes + edges).
 */
export function useUndoRedo() {
  const undo = useProjectStore((s) => s.undo);
  const redo = useProjectStore((s) => s.redo);
  const canUndo = useProjectStore((s) => s.canUndo);
  const canRedo = useProjectStore((s) => s.canRedo);
  const restoreSnapshot = useProjectStore((s) => s.restoreSnapshot);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const isModifier = e.metaKey || e.ctrlKey;
      if (!isModifier) return;

      // Ne pas intercepter quand l'utilisateur tape dans un champ
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return;
      }

      if (e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        if (canUndo()) {
          const entry = undo();
          if (entry) restoreSnapshot(entry.snapshot as { nodes: never[]; edges: never[] });
        }
      } else if ((e.key === 'z' && e.shiftKey) || e.key === 'y') {
        e.preventDefault();
        if (canRedo()) {
          const entry = redo();
          if (entry) restoreSnapshot(entry.snapshot as { nodes: never[]; edges: never[] });
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [undo, redo, canUndo, canRedo, restoreSnapshot]);
}
